import { GoogleAdsConnectionSchema } from "@redotech/redo-integrations-definitions-common/integration/google-ads/google-ads-definition";
import * as z from "zod";

export const getGoogleAdsIntegration = {
  name: "getGoogleAdsIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    customerId: z.string().optional(),
    connections: z.array(GoogleAdsConnectionSchema),
    /**
     * The stored grant is missing a scope we now request, so conversions cannot
     * be uploaded until the merchant authorizes again. False when there is no
     * integration at all — that is a store to connect, not one to reconnect.
     */
    needsReconsent: z.boolean(),
  }),
};
